<template>
  <page>
    <v-card>
      <!-- <v-toolbar dense color="grey lighten-3" flat>
        <v-icon>mdi-magnify</v-icon>
        <v-toolbar-title v-if="query">Miscellaneous Claims Parameters
          <v-btn text color="primary" v-on="on" @click="query = false" v-if="query">
            Edit
            <v-icon right>mdi-pencil</v-icon>
          </v-btn>
        </v-toolbar-title>
        <v-toolbar-title v-else>Upload Treaty Premium & Commission</v-toolbar-title>
      </v-toolbar> -->
      <v-card-text>
        <v-container fluid grid-list-lg>
          <v-layout row wrap>
            <v-flex lg6 md6 xs12>
              <v-autocomplete
                :items="acctTypeList"
                :label="labels.riType"
                v-model="form.riType"
                item-text="label"
                item-value="value"
                data-vv-name="riType"
                :data-vv-as="labels.riType"
                :error-messages="errors.collect('riType')"
                v-validate="'required'"
              ></v-autocomplete>
            </v-flex>
            <v-flex lg6 md6 xs12>
              <v-autocomplete
                :items="tgtMthList"
                :label="labels.acctMth"
                v-model="form.acctMth"
                item-text="label"
                item-value="value"
                data-vv-name="form.acctMth"
                :data-vv-as="labels.acctMth"
                :error-messages="errors.collect('form.acctMth')"
                v-validate="'required'"
              ></v-autocomplete>
            </v-flex>
            <v-flex lg6 md6 xs12>
              <v-autocomplete
                :items="currYrList"
                :label="labels.acctYr"
                v-model="form.acctYr"
                item-text="label"
                item-value="value"
                data-vv-name="form.acctYr"
                :data-vv-as="labels.acctYr"
                :error-messages="errors.collect('form.acctYr')"
                v-validate="'required'"
              ></v-autocomplete>
            </v-flex>
            <!-- <v-flex xs6 sm4 md2 xl2>
              <v-text-field
                v-model="form.acctMth"
                :label="labels.acctMth"
                :error-messages="errors.collect('form.acctMth')"
                data-vv-name="form.acctMth"
                :data-vv-as="form.acctMth"
                v-validate="'entry'"
                :disabled="true"
              ></v-text-field>
            </v-flex> -->
            <!-- <v-flex lg6 md6 xs12>
              <v-text-field
                v-model="form.acctYr"
                :label="labels.acctYr"
                :error-messages="errors.collect('form.acctYr')"
                data-vv-name="form.acctYr"
                :data-vv-as="form.acctYr"
                v-validate="'entry'"
                :disabled="true"
              ></v-text-field>
            </v-flex> -->
            <!-- <v-flex xl6 md6 xs12>
              <cal-picker :label="labels.fromDate" v-model="form.fromDate" :error-messages="errors.collect('fromDate')" data-vv-name="fromDate" :data-vv-as="labels.fromDate" v-validate="'required'"></cal-picker>
            </v-flex>
            <v-flex xl6 md6 xs12>
              <cal-picker :label="labels.toDate" v-model="form.toDate" :error-messages="errors.collect('toDate')" data-vv-name="toDate" :data-vv-as="labels.toDate" v-validate="'required'"></cal-picker>
            </v-flex>
            <v-flex xl6 md6 xs12>
              <cal-picker :label="labels.acctEndPeriod" v-model="form.acctEndPeriod" :error-messages="errors.collect('acctEndPeriod')" data-vv-name="acctEndPeriod" :data-vv-as="labels.acctEndPeriod" v-validate="'required'"></cal-picker>
            </v-flex> -->
            <v-flex xl6 md6 xs12>
              <v-text-field v-model="form.ttyRef" :label="labels.ttyRef" :error-messages="errors.collect('ttyRef')" data-vv-name="ttyRef" :data-vv-as="labels.ttyRef"
                append-icon="mdi-magnify" readonly @click:append="getHelpList('ttyRef')" :disabled="this.disableTtyRefNo"/>
            </v-flex>
            <!-- <v-flex xs4>
              <v-checkbox :label="labels.createTtyMaster" v-model="form.createTtyMaster" data-vv-name="createTtyMaster" :data-vv-as="labels.createTtyMaster" :error-messages="errors.collect('createTtyMaster')" hide-details></v-checkbox>
            </v-flex> -->
          </v-layout>
          <v-dialog v-model="showErrorDialog" width="800px" >
            <v-card>
              <v-toolbar dense color="grey lighten-3" flat>
                <v-icon>mdi-information</v-icon>
                <v-toolbar-title>System Information</v-toolbar-title>
                <v-spacer></v-spacer>
              </v-toolbar>
              <v-card-text>
                <div v-if="messages.length > 0" class="pb-3">
                <span class="info-dialog-msg-header">Oops something went wrong...</span>
                <v-spacer class="mt-2"></v-spacer>
                <ul class="showErrorMsgs">
                  <li v-for="(error, index) in messages" :key="index">
                  {{error.message}}
                  </li>
                </ul>
                </div>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="red darken-1" text @click.native="showErrorDialog = false">Close</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-container>
      </v-card-text>
      <v-btn color="error" dark class=" mr-2" @click.prevent="doCancel">Cancel<v-icon dark right>mdi-cancel</v-icon></v-btn>
      <v-btn color="primary" dark class=" mr-2" @click="doBatchRel" :loading="submitting">
        Post
        <v-icon right>mdi-file-send </v-icon>
      </v-btn>
    </v-card>
    <v-dialog v-model="showTtyRefHelpList" width="900px" persistent>
      <multi-tty-master-tty-ref-stmt-ref-help-list v-if="showTtyRefHelpList" :ttyRef="ttyRef" :riType="form.riType" :acctMth="form.acctMth" :acctYr="form.acctYr" @close="showTtyRefHelpList = false" @doAssign="doAssign($event)"></multi-tty-master-tty-ref-stmt-ref-help-list>
    </v-dialog>
  </page>
</template>

<script>
import MessageMixin from '@/mixins/message'
import { expandURI } from '@/utils/ajax'
import MultiTtyMasterTtyRefStmtRefHelpList from '@/components/core/common/dialog/MultiTtyMasterTtyRefStmtRefHelpList.vue'
import { acctType, tgtMth } from '@/const/params'
export default {
  data() {
    return {
      currYrList: [],
      uploadTtyPremComm: 'uploadTtyPremComm',
      submitting: false,
      showErrorDialog: false,
      labels: {
        riType: 'RI Type',
        acctMth: 'Account Month',
        acctYr: 'Account Year',
        fromDate: 'From Date',
        toDate: 'To Date',
        acctEndPeriod: 'Account End Period',
        createTtyMaster: 'Create New Treaty Master',
        ttyRef: 'Treaty Ref',
        uploadTtyPremComm: 'Upload Treaty Premium & Commission'
      },
      form: {
        riType: 'O',
        acctMth: undefined,
        acctYr: undefined,
        fromDate: undefined,
        toDate: undefined,
        acctEndPeriod: undefined,
        ttyRef: 'All',
        createTtyMaster: true
      },
      ttyRef: '',
      acctMth: '',
      acctYr: '',
      query: false,
      showTtyRefHelpList: false,
      disableTtyRefNo: false
    }
  },
  watch: {
    'displayErrorDialog': {
      handler: function (messages) {
        if (messages && messages.length > 0) {
          this.showErrorDialog = true
        }
      },
      deep: true
    }
  },
  methods: {
    async doInit() {
      await Promise.all([this.$store.dispatch('batchRelMthlyTtyStmtInit')])
      var dt = new Date()
      var count = 0
      const convertList = {
        label: dt.getFullYear() + 1,
        value: dt.getFullYear() + 1
      }
      this.currYrList.push(convertList)
      while (count <= 8) {
        const convertList = {
          label: dt.getFullYear() - count,
          value: dt.getFullYear() - count
        }
        this.currYrList.push(convertList)
        count++
      }
    },
    doCancel() {
      this.$router.push({ name: 'specFuncTtyAcct' })
    },
    getHelpList(fieldName) {
      if (fieldName === 'ttyRef') {
        this.showTtyRefHelpList = true
        this.ttyRef = this.form.ttyRef
        this.acctMth = this.form.acctMth
        this.acctYr = this.form.acctYr
      }
    },
    doAssign(Obj) {
      this.form.ttyRef = Obj.finalSelectedItems.toString()
    },
    doBatchRel() {
      this.submitting = true
      this.$validator.validateAll().then(result => {
        if (result) {
          this.getBatchRelProcess()
        } else {
          this.promptFieldCheck()
          this.submitting = false
        }
      })
    },
    async getBatchRelProcess() {
      const apiURI = this.menu.getBatchRelMthlyTtyStmtProcess
      if (apiURI) {
        try {
          const result = await this.$http.get(expandURI(apiURI, this.form))
          if (result) {
            this.$toast.success('Job successfully submitted to batch job process.')
            // this.$router.push({ name: 'uploadTtyPremComm' })
          }
          this.submitting = false
        } catch (err) {
          this.submitting = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
      this.submitting = false
    }
  },
  computed: {
    menu() {
      return this.$store.state.specFuncTtyAcct.batchRelMthlyTtyStmt.menu
    },
    displayErrorDialog() {
      return this.messages
    },
    acctTypeList() {
      let result = []
      Object.keys(acctType).forEach(function (key) {
        const status = acctType[key]
        result.push({
          label: status,
          value: key
        })
      })
      return result
    },
    tgtMthList() {
      let result = []
      Object.keys(tgtMth).forEach(function (key) {
        const status = tgtMth[key]
        result.push({
          label: status,
          value: key
        })
      })
      return result
    }
  },
  created() {
    this.doInit()
  },
  mixins: [
    MessageMixin
  ],
  components: {
    MultiTtyMasterTtyRefStmtRefHelpList
  }
}
</script>
